import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as animationData from '../../../animations/recharge_card_lottie_animation/FASTag_Recharge_animation.json';
import Recharge_card_lottie_animation from '../../../animations/recharge_card_lottie_animation/Recharge_card_lottie_animation';
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import Proceed_btn from '../../../common_components/common_btn/proceed_btn/Proceed_btn';
import All_providers_providers from '../../../common_components/common_cards/all_providers/All_providers';
import Bill_payments from '../../../home/bill_payments/Bill_payments';
import Contribution from '../../../home/contribution/Contribution';

function DTH_Recharge() {
    const providers = [
        { id: 1, providerName: "Induslnd Bank FASTag", logo: "/assets/images/services/all_providers/fastag/induslnd-bank.png" },
        { id: 2, providerName: "Bank Of Baroda FAStag", logo: "/assets/images/services/all_providers/fastag/BOB.png" },
        { id: 3, providerName: "Induslnd Bank FASTag", logo: "/assets/images/services/all_providers/fastag/induslnd-bank.png" },
        { id: 4, providerName: "Bank Of Baroda FAStag", logo: "/assets/images/services/all_providers/fastag/BOB.png" },
        { id: 5, providerName: "Induslnd Bank FASTag", logo: "/assets/images/services/all_providers/fastag/induslnd-bank.png" },
        { id: 6, providerName: "Bank Of Baroda FAStag", logo: "/assets/images/services/all_providers/fastag/BOB.png" },
    ];

    const services = [
        {
            id: 1,
            img: "/assets/images/home/bill_payments/money.png",
            title: "Mobile Recharge",
            baseLink: "/mobile-recharge",
        },
        {
            id: 2,
            img: "/assets/images/home/bill_payments/satellite-dish.png",
            title: "DTH Recharge",
            baseLink: "/dth-recharge",
        },
        {
            id: 3,
            img: "/assets/images/home/bill_payments/light-bulb.png",
            title: "Electricity Bill",
            baseLink: "/electricity-recharge",
        },
        {
            id: 4,
            img: "/assets/images/home/bill_payments/gas-stove.png",
            title: "Gas Cylinder",
            baseLink: "/gas-recharge",
        },
    ];

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    const navigate = useNavigate();

    const breadcrumbData = [
        { label: "Services", path: "/services", active: false },
        { label: "FASTag Recharges", active: true }
    ];

    // -----------------------
    // ✅ State for selected amount
    // -----------------------
    const [selectedAmount, setSelectedAmount] = useState(null);

    // Recommended recharge amounts
    const recommendedAmounts = [199, 249, 299, 349, 399, 449, 499, 599, 699, 799, 899, 999];

    const options = [
        { value: 'airtel', label: 'Airtel DTH' },
        { value: 'tatasky', label: 'Tata Sky' },
        { value: 'dish', label: 'Dish TV' },
        { value: 'sun', label: 'Sun Direct' }
    ];

    return (
        <>
            <Common_recharge_page_banner
                title="FASTAG RECHARGES"
                breadcrumbItems={breadcrumbData}
            />

            <section className="Mobile_Recharge DTH_Recharge">
                <div className="container">
                    <div className="Mobile_Recharge_container">
                        <div className="row">
                            <div className="col-md-7">
                                {/* Left Side - Form */}
                                <div className="recharge_form_section form_box_section">
                                    <Form className="recharge_form">
                                        <div className="form_row">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <Form.Group controlId="operator" className="form_field">
                                                        <Form.Label>Fastag Name</Form.Label>
                                                        <Select placeholder="Select FASTag Name" options={options} />
                                                    </Form.Group>
                                                </div>


                                                <div className="col-md-6">
                                                    <Form.Group controlId="subscriberID" className="form_field">
                                                        <Form.Label>Vehicle Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Vehicle Number"
                                                        />
                                                        <Form.Text className="muted_text">
                                                            Please Enter Valid Vehicle Number
                                                        </Form.Text>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-12">
                                                    <Form.Group controlId="recommendedAmounts" className="form_field">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <Form.Label>Or choose from recommended amounts</Form.Label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="choose_list_holder">
                                                                    {recommendedAmounts.map((amount, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className={`amount_option ${selectedAmount === amount ? 'active' : ''}`}
                                                                            onClick={() => setSelectedAmount(amount)}
                                                                        >
                                                                            ₹ {amount}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-12">
                                                    <div className="btn_holder">
                                                        <Proceed_btn
                                                            btnText="Continue"
                                                            className="save_changes_btn"
                                                            onClick={() => navigate("/fastag-recharge-details-plans")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>

                            <div className="col-md-5">
                                {/* Right Side - Cashback Section */}
                                <div className="cashback_offer_section form_box_section">
                                    <div className="cashback_box">
                                        <div className="heading_holder">
                                            <div className="cashback_heading">
                                                <h5>QUICK & SECURE</h5>
                                                <h5> FASTAG RECHARGE</h5>
                                            </div>
                                            <span className="tnc_text">*T&C Apply</span>
                                        </div>
                                        <p>Never miss a recharge get FASTag reminders and stay toll-ready.</p>
                                    </div>

                                    <div className="recharge_lottie_holder">
                                        <Recharge_card_lottie_animation defaultOptions={defaultOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <All_providers_providers providers={providers}
                showSearch={false}
                showStateName={false}
                showDivider={false} />
            <Bill_payments
                sectionTitle='EXPLORE OUR OTHER SERVICES'
                sectionSubtitle='From recharges to rewards, discover everything we offer in one place'
                services={services}
            />
            <Contribution />
        </>
    );
}

export default DTH_Recharge;
